<app-domain-navigation [domains]="domains">
    <ng-template let-data>
        <app-rubric-subdomain-summary [domain]="data.domain" [rubricComponent]="data.subdomain"
            [currentRubricComponent]="currentRubricComponent" [domainNavigationData]="domainNavigationData"
            [showFocusAreas]="true" [isFocusArea]="isFocusArea(data.subdomain)" [resourceFile]="resourceFile"
            [showEvaluatorRating]="showEvaluatorRating"
            [showTeacherRating]="showTargetUser">
        </app-rubric-subdomain-summary>
    </ng-template>
</app-domain-navigation>

<app-rubric-domain-filter [filterType]="filterType" [showTargetUser]="showTargetUser" [showTeacherFilter]="!isTargetUser"
    [includeFocusAreasFilter]="true">
</app-rubric-domain-filter>

<hr />
<div class="form-title">
    <div class="row">
        <div class="col-6">
            <h2>Evidence</h2>
        </div>
        <div class="col-6">
            <div class="text-end">
                <button *ngIf="canSave()" type="button" class="btn btn-secondary me-2 save-button" (click)="onSave()"><i
                        class="far fa-save me-1"></i>Save</button>
                <paetep-notify-of-comment *ngIf="canNotifyOfComment()" class="me-2"
                    [observationType]="ObservationTypeValues.NTPE"
                    [observationId]="observationDetails?.ntpeObservationId"
                    [observationTargetUserId]="observationDetails?.targetUserId"
                    [receivingUserIds]="isTargetUser ? [observationDetails?.evaluatingUserId] : isEvalUser ? [observationDetails?.targetUserId] : [observationDetails?.evaluatingUserId, observationDetails?.targetUserId]"></paetep-notify-of-comment>
                <paetep-publish-all-comments-button *ngIf="!observationDetails?.permissions?.rubric?.canSubmit"
                    class="me-2"></paetep-publish-all-comments-button>
                <button *ngIf="canSubmitRating()" type="button" class="btn btn-primary me-2 submit-button"
                    (click)="onSubmit()"><i class="far fa-save me-1"></i>Submit Rating</button>
            </div>
        </div>
    </div>

    <div class="row mb-2">
        <div class="col-sm-12">
            For each focus area, add updates and evidence as needed. Submit updates to your supervisor. At the end
            of the year, add your final updates and select the appropriate self-assessment ratings. Submit your
            ratings to your supervisor.
            <br />
            <br />
            Note - For the end of year submission, users must select ratings for each focus area. However, as
            directed by their supervisor, users may also select ratings for any or all component areas.
        </div>
    </div>
</div>

<br />
<app-subdomains-display
    [domains]="domains"
    [filterType]="filterType"
    [currentSubdomain]="currentRubricComponent"
    [focusAreas]="focusAreas">
    <ng-template let-data>
        <app-ntpe-rubric-subdomain-form
            [rubricComponent]="data.subdomain"
            [observationDetails]="observationDetails"
            [observationSummary]="observationSummary"
            [showTargetUser]="showTargetUser"         
            [form]="getRubricComponentGroup(data.domain, data.subdomain.Value)"
            [filterType]="filterType">
        </app-ntpe-rubric-subdomain-form>
    </ng-template>
</app-subdomains-display>